module.exports = __webpack_public_path__ + "static/self_Employed_Professional-98619985da698dae9e363198839897c9.svg";